import React, { useState } from 'react';
import { colors, radius, shadows } from '../styles/theme';

const KpiCard = ({ title, value, color = colors.primary, icon, subtitle, tooltip, trend, onClick }) => {
  const [showTip, setShowTip] = useState(false);

  const trendColor = trend && trend.value != null
    ? (trend.value > 0 ? colors.success : trend.value < 0 ? colors.danger : colors.textTertiary)
    : null;
  const trendSign = trend && trend.value != null ? (trend.value > 0 ? '\u25B2' : trend.value < 0 ? '\u25BC' : '\u25CF') : '';

  return (
    <div
      onClick={onClick}
      style={{
        background: colors.surface,
        padding: '20px',
        borderRadius: radius.lg,
        borderLeft: `4px solid ${color}`,
        boxShadow: shadows.sm,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'transform 0.15s, box-shadow 0.15s',
        position: 'relative',
      }}
      onMouseEnter={(e) => { if (onClick) { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = shadows.md; } }}
      onMouseLeave={(e) => { if (onClick) { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = shadows.sm; } }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '10px' }}>
            <span style={{
              fontSize: '11px', color: colors.textTertiary,
              textTransform: 'uppercase', letterSpacing: '0.06em', fontWeight: 600,
            }}>{title}</span>
            {tooltip && (
              <span
                onMouseEnter={() => setShowTip(true)}
                onMouseLeave={() => setShowTip(false)}
                style={{
                  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                  width: '16px', height: '16px', borderRadius: radius.full,
                  background: colors.border, color: colors.textSecondary,
                  fontSize: '10px', fontWeight: '700', cursor: 'help', position: 'relative',
                }}
              >
                i
                {showTip && (
                  <div style={{
                    position: 'absolute', bottom: '22px', left: '0',
                    transform: 'translateX(-40%)',
                    background: colors.secondary, color: 'white',
                    padding: '10px 14px', borderRadius: radius.md,
                    fontSize: '11px', fontWeight: 'normal', textTransform: 'none',
                    letterSpacing: 'normal', lineHeight: '1.5', whiteSpace: 'pre-wrap',
                    minWidth: '220px', maxWidth: '300px', zIndex: 1000,
                    boxShadow: shadows.lg, textAlign: 'left',
                  }}>
                    {tooltip}
                  </div>
                )}
              </span>
            )}
          </div>
          <div style={{
            fontSize: '26px', fontWeight: '700', color: colors.textPrimary,
            lineHeight: '1.1', letterSpacing: '-0.02em',
          }}>{value}</div>
          {subtitle && (
            <div style={{ fontSize: '11px', color: colors.textTertiary, marginTop: '8px' }}>{subtitle}</div>
          )}
          {trend && trend.value != null && (
            <div style={{
              fontSize: '11px', marginTop: '8px', color: trendColor, fontWeight: '600',
              display: 'flex', alignItems: 'center', gap: '3px',
            }}>
              <span style={{ fontSize: '9px' }}>{trendSign}</span>
              {Math.abs(trend.value).toFixed(1)}% {trend.label || ''}
            </div>
          )}
        </div>
        {icon && (
          <div style={{
            width: '40px', height: '40px', borderRadius: radius.md,
            background: `${color}10`, display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '20px', flexShrink: 0,
          }}>
            {icon}
          </div>
        )}
      </div>
    </div>
  );
};

export default KpiCard;
